import { render, staticRenderFns } from "./generalArticles.vue?vue&type=template&id=24ddd1f4&scoped=true&"
import script from "./generalArticles.vue?vue&type=script&lang=js&"
export * from "./generalArticles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24ddd1f4",
  null
  
)

export default component.exports